// This file is generate automatically by NPM// Don't edit this fileimport {TabTutorial} from '../../../templates/flexibles/tab-tutorial/tab-tutorial.js'
import {PlotPricing} from '../../../templates/flexibles/plot-pricing/plot-pricing.js'
import {SliderLogo} from '../../../templates/flexibles/slider-logo/slider-logo.js'
import {FullForm} from '../../../templates/flexibles/full-form/full-form.js'
import {TableOffer} from '../../../templates/flexibles/table-offer/table-offer.js'
import {TabNavigation} from '../../../templates/flexibles/tab-navigation/tab-navigation.js'
import {CalculatorFreelance} from '../../../templates/flexibles/calculator-freelance/calculator-freelance.js'
import {BigSubmenu} from '../../../templates/flexibles/big-submenu/big-submenu.js'
import {ProductFeatures} from '../../../templates/flexibles/product-features/product-features.js'
import {Header} from '../../../templates/flexibles/header/header.js'
import {GridCountdownTimer} from '../../../templates/flexibles/grid-countdown-timer/grid-countdown-timer.js'
import {Calculator} from '../../../templates/flexibles/calculator/calculator.js'
import {PostsList} from '../../../templates/flexibles/posts-list/posts-list.js'

export let flexiblesController = {
  TabTutorial: TabTutorial,
  PlotPricing: PlotPricing,
  SliderLogo: SliderLogo,
  FullForm: FullForm,
  TableOffer: TableOffer,
  TabNavigation: TabNavigation,
  CalculatorFreelance: CalculatorFreelance,
  BigSubmenu: BigSubmenu,
  ProductFeatures: ProductFeatures,
  Header: Header,
  GridCountdownTimer: GridCountdownTimer,
  Calculator: Calculator,
  PostsList: PostsList
}